import API from '@/api'
import normalizeFormData from '@/utils/carForm/normalize'
import router from '@/router'

export const moduleName = 'auctionManager'

export const actionTypes = {
  ACTION_INIT_WS: 'ACTION_INIT_WS',
  ACTION_JOIN_TO_CAR_MANAGER: 'ACTION_JOIN_TO_CAR_MANAGER',
  ACTION_LOAD_AUCTIONS: 'ACTION_LOAD_AUCTIONS',
  ACTION_UPDATE_AUCTION_CAR: 'ACTION_UPDATE_AUCTION_CAR',
  ACTION_PUBLISH_AUCTION_CAR: 'ACTION_PUBLISH_AUCTION_CAR',
  ACTION_ADD_PHOTO_TO_JOINED_CAR: 'ACTION_ADD_PHOTO_TO_JOINED_CAR',
  ACTION_REMOVE_CAR_PHOTO: 'ACTION_REMOVE_CAR_PHOTO',
  ACTION_SET_STATE: 'ACTION_SET_STATE',
  ACTION_ADD_PDF_TO_CAR: 'ACTION_ADD_PDF_TO_CAR',
  ACTION_CAR_FEATURED: 'ACTION_CAR_FEATURED',
  ACTION_CAR_FEATURED_IMAGE: 'ACTION_CAR_FEATURED_IMAGE',
  ACTION_PAGE_REOLAD: 'ACTION_PAGE_REOLAD',
  ACTION_COMMENTS: 'ACTION_COMMENTS',
  ACTION_LOAD_AUCTIONS_MANAGER_DATA: 'ACTION_LOAD_AUCTIONS_MANAGER_DATA',
  ACTION_LOAD_MARKETPLACE_AUCTIONS: 'ACTION_LOAD_MARKETPLACE_AUCTIONS',
  ACTION_LOAD_MARKETPLACE_SOLD_AUCTIONS: 'ACTION_LOAD_MARKETPLACE_SOLD_AUCTIONS',
  ACTION_LOAD_TESLA_VEHICLES: 'ACTION_LOAD_TESLA_VEHICLES',
  ACTION_LOAD_TESLA_VEHICLE_BY_ID: 'ACTION_LOAD_TESLA_VEHICLE_BY_ID',

}

export const getterTypes = {
  GETTER_AUCTIONS: 'GETTER_AUCTIONS',
  GETTER_AUCTIONS_COUNT: 'GETTER_AUCTIONS_COUNT',
  GETTER_ADDED_CAR_FORM_IMAGES: 'GETTER_ADDED_CAR_FORM_IMAGES',
  GETTER_PAGE_RELOAD: 'GETTER_PAGE_RELOAD',
  GETTER_TESLA_AUCTIONS: 'GETTER_TESLA_AUCTIONS',
  GETTER_TESLA_AUCTIONS_COUNT: 'GETTER_TESLA_AUCTIONS_COUNT',
  GETTER_TESLA_AUCTION:"GETTER_TESLA_AUCTION"
}

export const mutationTypes = {
  MUTATION_SET_AUCTIONS: 'SET_AUCTIONS',
  MUTATION_ADD_CAR_FORM_IMAGES: 'MUTATION_ADD_CAR_FORM_IMAGES',
  MUTATION_UNSET_CAR_FORM_IMAGES: 'MUTATION_UNSET_CAR_FORM_IMAGES',
  MUTATION_UPDATE_AUCTION: 'MUTATION_UPDATE_USER_CAR',
  MUTATION_UPDATE_CAR_BID: 'MUTATION_UPDATE_CAR_BID',
  MUTATION_ADD_AUCTION: 'MUTATION_ADD_AUCTION',
  MUTATION_ADD_CAR_FORM_PDF: 'MUTATION_ADD_CAR_FORM_PDF',
  MUTATION_SET_ROUTE: 'MUTATION_SET_ROUTE',
  MUTATION_SET_PAGE_RELOAD: 'MUTATION_SET_PAGE_RELOAD',
  MUTATION_SET_TESLA_AUCTIONS: "MUTATION_SET_TESLA_AUCTIONS",
  MUTATION_SET_TESLA_AUCTION_BY_ID: "MUTATION_SET_TESLA_AUCTION_BY_ID"
}

export default {
  moduleName,

  namespaced: true,

  state: () => ({
    auctions: [],
    auctionsCount: 0,
    teslaAuctions: [],
    teslaAuction: null,
    teslaAuctionsCount: 0,
    carForm: {
      images: []
    },
    route: null,
    isPageReload: false
  }),

  actions: {
    [actionTypes.ACTION_INIT_WS] ({ commit, getters, dispatch }) {
      const onNewAuction = ({ value }) => {
        commit(mutationTypes.MUTATION_ADD_AUCTION, value)
      }
      
      const onUpdateCar = ({ value }) => {
        commit(mutationTypes.MUTATION_UPDATE_AUCTION, value.car)
      }

      const onUpdateAuction = async ({ value  }) => {
        const currentRoute = getters[getterTypes.currentRoute];
        await dispatch(actionTypes.ACTION_LOAD_AUCTIONS, {
          take: currentRoute.query.take || 10,
          skip: currentRoute.query.skip || 0,
          search: currentRoute.query.search,
          all: true
        });
        // getPrevQuery(currentRoute)
      }

      const onNewBidPlaced = ({ value }) => {
        commit(mutationTypes.MUTATION_UPDATE_CAR_BID, value)
      }

      API.auctionManager.wsListeners[API.auctionManager.wsEvents.AUCTION_MANAGER_NEW_CAR](onNewAuction)
      API.auctionManager.wsListeners[API.auctionManager.wsEvents.CAR_MANAGER_UPDATE_CAR](onUpdateCar)
      API.auctionManager.wsListeners[API.auctionManager.wsEvents.AUCTION_MANAGER_UPDATE_CAR](onUpdateAuction)
      API.auctionManager.wsListeners[API.auctionManager.wsEvents.CAR_MANAGER_NEW_BID](onNewBidPlaced)
    },

    [actionTypes.ACTION_JOIN_TO_CAR_MANAGER]() {
      API.auctionManager.wsActions.ACTION_JOIN_TO_CAR_MANAGER()
    },
    [actionTypes.ACTION_PAGE_REOLAD]({ commit }, payload) {
      commit(mutationTypes.MUTATION_SET_PAGE_RELOAD, payload );
      return true
    },
    async [actionTypes.ACTION_SET_STATE]({ }, payload) {
      await API.auctionManager.setAuctionState(payload)
    },
    
    async [actionTypes.ACTION_LOAD_AUCTIONS_MANAGER_DATA] ({ commit }, payload) {
      const result = await API.auctionManager.loadAuctionManagerData(payload)
      const { cars, carsCount } = result.data
      commit(mutationTypes.MUTATION_SET_AUCTIONS, [cars, carsCount])
    },
    async [actionTypes.ACTION_LOAD_TESLA_VEHICLES] ({ commit }, payload) {
      const result = await API.auctionManager.loadTeslaAuctions(payload)
      const { data, count } = result.data
      commit(mutationTypes.MUTATION_SET_TESLA_AUCTIONS, [data, count])
    },
    async [actionTypes.ACTION_LOAD_TESLA_VEHICLE_BY_ID] ({ commit }, payload) {
      console.log("payload",payload)
      const result = await API.auctionManager.loadTeslaAuctionById(payload)
      const { data } = result.data
      commit(mutationTypes.MUTATION_SET_TESLA_AUCTION_BY_ID, [data])
      return data
    },
    async [actionTypes.ACTION_LOAD_MARKETPLACE_SOLD_AUCTIONS] ({ commit }, payload) {
      const result = await API.auctionManager.loadMarketplaceSoldAuctions(payload)
      const { cars, carsCount } = result.data
      commit(mutationTypes.MUTATION_SET_AUCTIONS, [cars, carsCount])
    },
    async [actionTypes.ACTION_LOAD_MARKETPLACE_AUCTIONS] ({ commit }, payload) {
      const result = await API.auctionManager.loadMarketplaceAuctions(payload)
      const { cars, carsCount } = result.data
      commit(mutationTypes.MUTATION_SET_AUCTIONS, [cars, carsCount])
    },
    async [actionTypes.ACTION_LOAD_AUCTIONS] ({ commit }, payload) {
      const result = await API.auctionManager.loadAuctions(payload)
      const { cars, carsCount } = result.data
      commit(mutationTypes.MUTATION_SET_AUCTIONS, [cars, carsCount])
    },

    async [actionTypes.ACTION_UPDATE_AUCTION_CAR] ({ commit, getters }, { formData, carId }) {
      const validFormData = normalizeFormData(formData)
      const images = getters[getterTypes.GETTER_ADDED_CAR_FORM_IMAGES]
      images.forEach(i => {
        validFormData.append(i.name, i.id)
      })
      await API.auctionManager.putCar({ carId, formData: validFormData })
      commit(mutationTypes.MUTATION_SET_PAGE_RELOAD, true )

    },

    async [actionTypes.ACTION_PUBLISH_AUCTION_CAR] ({commit, getters }, { formData, carId }) {
      const validFormData = normalizeFormData(formData)
      const images = getters[getterTypes.GETTER_ADDED_CAR_FORM_IMAGES]
      images.forEach(i => {
        validFormData.append(i.name, i.id)
      })
      await API.auctionManager.publishCar({ carId, formData: validFormData })
      commit(mutationTypes.MUTATION_SET_PAGE_RELOAD, true )

    },

    async [actionTypes.ACTION_ADD_PHOTO_TO_JOINED_CAR]({ commit }, { idx, file, name, carId,illustratorId }) {
      const formData = new FormData()
      formData.append(name, file)
      formData.append("carId", carId)
      if(illustratorId){
        formData.append("illustratorId", illustratorId)

      }
      const image = await API.auctionManager.addPhotoToJoined(formData)
      commit(mutationTypes.MUTATION_ADD_CAR_FORM_IMAGES, { name, id: image.data.id })
      return {
        arrId: idx,
        uploadImageId: image.data.id,
        data: image.data
      }
    },

    async [actionTypes.ACTION_ADD_PDF_TO_CAR]({ commit }, { carId, file, name }) {
      const formData = new FormData()
      formData.append(name, file)
      formData.append('carId', carId)
      const image = await API.auctionManager.addPdfToCar(formData)
      commit(mutationTypes.MUTATION_ADD_CAR_FORM_PDF, { name, id: image.data.url })
      return {
        arrId: 0,
        data: image.data
      }
    },

    async [actionTypes.ACTION_REMOVE_CAR_PHOTO](context, payload) {
      await API.auctionManager.deleteCarPhoto.call(this, payload)
    },
    [actionTypes.ACTION_CAR_FEATURED]({commit}, payload) {
      commit(mutationTypes.MUTATION_SET_ROUTE, payload.route )
      API.carManager.wsActions.ACTION_CAR_FEATURED(payload)
    },
    async [actionTypes.ACTION_CAR_FEATURED_IMAGE]({commit}, payload) {
      const image = await API.auctionManager.addCarMainImage(payload)
      commit(mutationTypes.MUTATION_SET_PAGE_RELOAD, true )
      return true
    },
    [actionTypes.ACTION_COMMENTS]({commit}, payload) {
      API.carManager.wsActions.ACTION_COMMENTS(payload)
    },
  },

  mutations: {
    [mutationTypes.MUTATION_ADD_CAR_FORM_IMAGES](state, imageId) {
      state.carForm.images.push(imageId)
    },
    [mutationTypes.MUTATION_ADD_CAR_FORM_PDF](state, url) {
      state.carForm.historyReport = url.id
    },
    [mutationTypes.MUTATION_UNSET_CAR_FORM_IMAGES](state) {
      state.carForm.images = []
    },
    [mutationTypes.MUTATION_SET_TESLA_AUCTIONS](state, [auctions, auctionsCount]) {
      state.teslaAuctions = auctions
      state.teslaAuctionsCount = auctionsCount
    },
    [mutationTypes.MUTATION_SET_TESLA_AUCTION_BY_ID](state, [auction]) {
      debugger
      state.teslaAuction = auction
    },
    [mutationTypes.MUTATION_SET_AUCTIONS](state, [auctions, auctionsCount]) {
      state.auctions = auctions
      state.auctionsCount = auctionsCount
    },
    [mutationTypes.MUTATION_UPDATE_AUCTION](state, auction) {
      const auctionIndex = state.auctions.findIndex(a => a.id === auction.id)
      if (auctionIndex >= 0) {
        state.auctions.splice(auctionIndex, 1, auction)
      }
    },
    [mutationTypes.MUTATION_ADD_AUCTION](state, auction) {
      if (state.auctions.some(c => c.id === auction.id)) return
      const maxAuctions = Number(router.currentRoute.query.take) || 10

      state.auctions.unshift(auction)
      if (state.auctions.length > maxAuctions) {
        state.auctions.pop()
      }
    },
    [mutationTypes.MUTATION_UPDATE_CAR_BID](state, bid) {
      state.auctions = state.auctions.map(a => {
        //console.log(a.id, bid.placedBid.carId)
        if (a.id === bid.placedBid.carId) {
          a.bids.push(bid.placedBid)
        }
        return a
      })
    },
    [mutationTypes.MUTATION_SET_ROUTE](state, route) {
      state.route = route
    },
    [mutationTypes.MUTATION_SET_PAGE_RELOAD](state, pageReload) {
      state.isPageReload = pageReload
    },
  },

  getters: {
    [getterTypes.GETTER_TESLA_AUCTIONS]: (state) => state.teslaAuctions,
    [getterTypes.GETTER_TESLA_AUCTIONS_COUNT]: (state) => state.teslaAuctionsCount,
    [getterTypes.GETTER_TESLA_AUCTION]: (state) => state.teslaAuction,
    [getterTypes.GETTER_AUCTIONS]: (state) => state.auctions,
    [getterTypes.GETTER_AUCTIONS_COUNT]: (state) => state.auctionsCount,
    [getterTypes.GETTER_ADDED_CAR_FORM_IMAGES]: (state) => state.carForm.images,
    [getterTypes.currentRoute]: (state) => state.route,
    [getterTypes.GETTER_PAGE_RELOAD]: (state) => state.isPageReload,
  }
}
function getPrevQuery(route) {
  const obj = {
    skip: parseInt(route.query.skip) || 0,
    take: parseInt(route.query.take) || 10
  };

  if (route.query.search) {
    obj.search = route.query.search;
  }
  const currentRoute = route.path;
  router.push({ query: obj });

}